import * as React from 'react';
import type { SVGIconProps } from './Icon.types';

const LayoutTopIcon = React.forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        ref={forwardedRef}
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <title>{props.title}</title>

        <path
          clipRule="evenodd"
          d="M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM4 10V19H20V10H4ZM4 8H20V5H4V8Z"
          fill={color}
          fillRule="evenodd"
        />
      </svg>
    );
  },
);

export default LayoutTopIcon;
